import Enum from '@packages/utilities/enum';

export const RESPONSE_TYPE = Enum('code', 'token') as {
  [key: string]: string;
};
export const GRANT_TYPE = Enum('client_credentials', 'authorization_code') as {
  [key: string]: string;
};

// RFC_AUTH_CODE_GRANT_ERRORS
// https://www.rfc-editor.org/rfc/rfc6749#section-4.1.2.1
//   - invalid_request
//   - unauthorized_client
//   - access_denied
//   - unsupported_response_type
//   - invalid_scope
//   - server_error
//   - temporarily_unavailable
const AUTHORIZATION_ERRORS: {
  [key: string]: string;
} = Enum('unsupported_response_type', 'access_denied', 'invalid_scope');

// RFC_ACCESS_TOKEN_RESP_ERRORS
//   - invalid_request
//   - invalid_client
//   - invalid_grant
//   - unauthorized_client
//   - unsupported_grant_type
//   - invalid_scope
export const ACCESS_TOKEN_ERRORS: {
  [key: string]: string;
} = Enum(
  'unsupported_grant_type',
  'invalid_client',
  'invalid_grant',
  'invalid_request'
);

export const errors = {
  AUTHORIZATION_ERRORS,
  ACCESS_TOKEN_ERRORS,
} as const;

export const OAUTH_API_ERRORS = Enum(
  'BadRequest',
  'BadRequestError',
  'Conflict',
  'ConflictError',
  'Forbidden',
  'ForbiddenError',
  'InvalidAPIVersion',
  'LimitReachedError',
  'NotFound',
  'NotImplemented',
  'OAuthForbidden',
  'OAuthUnauthorized',
  'ProjectLimitReachedError',
  'PurchaseRequiredError',
  'RateLimit',
  'RateLimitError',
  'ServiceUnavailableError',
  'RemoteFileUploadFailedError',
  'UnsupportedVersion',
  'ValidationError',
  'SiteNotPublishedError',
  'InconsistentPublicationsError',
  'CollectionSchemaChangedError',
  'UsysDuplicateEmailError',
  'UsysInvalidEmailError',
  'UsysUsersLimitReachedError',
  'UsysUserNotFoundError',
  'UsysGroupNotFoundError'
) as {
  [key: string]: string;
};
